import type { SVGProps } from "react";

export default function CloseIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.9106 6.0899L6.08991 17.9106"
        stroke="currentColor"
        strokeWidth="1.92"
        strokeLinecap="round"
      />
      <path
        d="M17.9106 17.9105L6.08991 6.08978"
        stroke="currentColor"
        strokeWidth="1.92"
        strokeLinecap="round"
      />
    </svg>
  );
}
